module.exports = __webpack_public_path__ + "img/pink-grid.77d3b23.png";